module.exports = "https://static.wmbcdn.com/uniweb/images/40b98b2be6ecb06023d0aa50618ec622.svg";